import { SharedAgentInfo } from '@/types/agents'

const SHARED_TITLE_AGENT_PREFIX = 'shared:'

export interface SharedTitleAgentRef {
  ownerUsername: string
  slug: string
}

export function encodeSharedTitleAgent(agent: Pick<SharedAgentInfo, 'ownerUsername' | 'slug'>): string {
  return `${SHARED_TITLE_AGENT_PREFIX}${agent.ownerUsername}/${agent.slug}`
}

export function decodeSharedTitleAgent(value?: string | null): SharedTitleAgentRef | null {
  if (!value || !value.startsWith(SHARED_TITLE_AGENT_PREFIX)) return null
  const rest = value.slice(SHARED_TITLE_AGENT_PREFIX.length)
  const parts = rest.split('/')
  if (parts.length !== 2) return null
  const [ownerUsername, slug] = parts
  if (!ownerUsername || !slug) return null
  return { ownerUsername, slug }
}
